/** Who authored a MAIA chat message. */
export enum MaiaChatRole {
    USER = "USER",
    ASSISTANT = "ASSISTANT",
}

/** One turn in the MAIA conversation panel. */
export interface MaiaChatMessage {
    role: MaiaChatRole;
    text: string;
}
